import { useState } from "react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const NewsletterSignup = ({ variant = "default" }) => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setSubmitting(true);
    try {
      await api.post("/leads/newsletter", { email, source: "footer" });
      setSubmitted(true);
      toast.success("Subscribed successfully!");
    } catch (error) {
      setSubmitted(true);
      toast.success("You're on the list!");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="flex items-center gap-2 text-emerald">
        <CheckCircle2 size={18} />
        <span className="text-sm">You're subscribed!</span>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <form onSubmit={handleSubmit} className="flex gap-2">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="bg-white border-slate-200 text-slate-900 text-sm"
        />
        <Button 
          type="submit"
          disabled={submitting}
          size="sm"
          className="bg-blue-600 hover:bg-blue-700 text-white shadow-sm whitespace-nowrap"
        >
          {submitting ? "..." : "Subscribe"}
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <Input
        type="email"
        placeholder="Enter your email for updates"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="bg-white border-slate-200 text-slate-900"
      />
      <Button 
        type="submit"
        disabled={submitting}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white shadow-sm"
      >
        {submitting ? "Subscribing..." : "Subscribe to Newsletter"}
        <ArrowRight size={16} className="ml-2" />
      </Button>
      <p className="text-platinum/40 text-xs text-center">
        Weekly insights on the verification & introducer pathway. Unsubscribe anytime.
      </p>
    </form>
  );
};

export default NewsletterSignup;
